/**
 * Billing quarter helpers. Quarters are offered DESCENDING from the current
 * (in-progress) quarter back to Q4 2013 - the first full quarter of the APX
 * backup history (data starts 2013-09-30). Only in-progress or past quarters
 * exist in the list by construction.
 */
import { toReportDate } from './reportDates';

const FLOOR = { year: 2013, q: 4 };

export function listBillingQuarters(now = new Date()) {
  const out = [];
  let year = now.getFullYear();
  let q = Math.floor(now.getMonth() / 3) + 1;
  const isCurrent = (y, qq) => y === now.getFullYear() && qq === Math.floor(now.getMonth() / 3) + 1;
  while (year > FLOOR.year || (year === FLOOR.year && q >= FLOOR.q)) {
    const m0 = (q - 1) * 3; // 0-based first month of the quarter
    out.push({
      value: `${year}-Q${q}`,
      label: `Q${q} ${year}`,
      start: toReportDate(new Date(year, m0, 1)),
      end: toReportDate(new Date(year, m0 + 3, 0)), // day 0 of next month = last day
      inProgress: isCurrent(year, q),
    });
    q -= 1;
    if (q === 0) { q = 4; year -= 1; }
  }
  return out;
}
